import { StatusTradeTrust } from "actions";
import { Dropdown, Input, Modal } from "components/common";
import { ActiveShipmentsContext, DocumentsContext, HomeContext } from "contexts";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import { getErrorMessage } from "utils";
import './index.scss';

export const NominateOwnerShip = ({open, onCancel}) => {
    const location = useLocation();
    const { handleSubmit, errors, register } = useForm();
    const { doNominateOwnerShip, documentInfo } = useContext(DocumentsContext);
    const { idDocumentSignature, invoking, setCallbackParties, walletVerify, setPleaseAwait, setStatusBlockChain, setCurrentStatus } = useContext(HomeContext);
    const { wallets } = useContext(ActiveShipmentsContext);
    const [accountSelect, setAccountSelect] = useState();
    const [loading, setLoading] = useState(false);
    const [wallestBackUp, setWallestBachUp] = useState([]);
    const pathnameArr = location.pathname.split('/');
    const docId = pathnameArr[pathnameArr.length - 1];

    useEffect(() => {
        setWallestBachUp(wallets);
    }, [wallets])

    const hanldSelectOption = (option) => {
        setAccountSelect(option);
    }

    const handlSubmit = () => {
        const payload = {
            merkleRoot: documentInfo?.merkleRoot,
            tokenRegistryAddress: documentInfo?.tokenRegistryAddress,
            organizationId: walletVerify?.orgId,
            walletPassword: invoking?.password,
            blockchain: 'Ethereum',
            invokingparty: invoking?.address,
            nominatedOwner: accountSelect?.address,
            isDemo: false
        };
        if(accountSelect){
            doNominateOwnerShip(idDocumentSignature ? idDocumentSignature : docId, payload, (data) => {
                setPleaseAwait(true);
                setCallbackParties(true);
                setStatusBlockChain([{key: 6, value: 'New owner nomination started'}]);
                setCurrentStatus(StatusTradeTrust.NEW_OWNER_NOMINATION_STARTED);
                if (data) onCancel();
            }); 
        }
    }

    const hanldSearch = (value) => {
        setLoading(true);
        setWallestBachUp(wallets.filter(x => x?.accountName?.toLowerCase().includes(value?.toLowerCase())));
        setLoading(false);
    }

    return (
        <Modal
            open={open}
            title="Nominate OwnerShip"
            className="tr__Nominate_OwnerShip"
            onCancel={onCancel}
            submitButton
            submitButtonLabel="Confirm"
            isBackDropClickable={false}
            renderForm={children => (
                <form onSubmit={handleSubmit(handlSubmit)}>
                    {children}
                </form>
            )}
        >
            <Dropdown
                label="Nominate account *"
                options={wallestBackUp.map(type => {
                    return {
                        _id: type._id,
                        key: type._id,
                        address: type.encWallet.address,
                        value: type.accountName + ` (${type.encWallet.address})`,
                        orgId: type.orgId
                    }
                })}
                placeholder="Select account"
                name="nominate"
                dropdownPosition="center"
                refs={register({ required: true })}
                error={!!errors.nominate}
                errorMessage={getErrorMessage(errors.nominate, "nominate account")}
                iconPosition = 'right'
                icon='icon-chevron-down'
                defaultValue=''
                onChange={option => hanldSelectOption(option)}
                searchLoading={loading}
                onInputChange={hanldSearch}
                mode="input"
            />
            <Input
                label="Nominate Account address *"
                placeholder="Nominate Account address *"
                disabled={true}
                defaultValue={accountSelect ? accountSelect.address : "" }
                className="input_value_default"
                name="nominateAddress"
                refs={register({ required: true })}
                error={!!errors.nominateAddress}
                errorMessage={getErrorMessage(errors.nominateAddress, "nominate account address")}
            />
        </Modal>
    )
}